export enum Price {
  From = 'от',
}
